import React from 'react';
import PropTypes from 'prop-types';
import { Tabbed } from 'components/Page';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Permissions } from 'components/Permissions';
import config from 'views/Users/config';

const UserAccount = ({ userId, showCancelButton }) => (
  <div className="bhp-users bhp-container">
    <Permissions.Consumer>
      {({ permissions }) => (
        <Tabbed
          canAdmin={permissions.CanAdminUsers()
            .hasPermissions()}
          reducer={{
            item: REDUCER_KEY.userAccount,
            list: REDUCER_KEY.peopleData
          }}
          item={{
            userId
          }}
          tabPosition="left"
          isEditMode
          config={{
            ...config.detail,
            parent: {
              id: userId
            },
            commands: {
              ...config.detail.commands,
              showCancelButton: showCancelButton && permissions.CanAdminUsers()
                .hasPermissions()
            }
          }}
          permissions={permissions}
        />
      )}
    </Permissions.Consumer>
  </div>
);

UserAccount.propTypes = {
  userId: PropTypes.number,
  showCancelButton: PropTypes.bool
};

UserAccount.defaultProps = {
  userId: null,
  showCancelButton: true
};

export default UserAccount;
